const carriers = [
  "Mutual of Omaha",
  "Prudential",
  "Lincoln Financial",
  "John Hancock",
  "AIG",
  "Transamerica",
  "Pacific Life",
  "Foresters Financial",
  "Banner Life",
  "Protective",
  "Nationwide",
  "AAA Life",
];

export default function TrustMarquee() {
  const loop = [...carriers, ...carriers];
  return (
    <section className="py-12 border-y border-border/60 bg-muted/40">
      <p className="text-center overline mb-6">Comparing top A-rated carriers</p>
      <div className="relative overflow-hidden">
        <div className="flex gap-16 animate-marquee whitespace-nowrap will-change-transform">
          {loop.map((c, i) => (
            <span
              key={i}
              className="font-serif text-2xl text-muted-foreground/70 italic tracking-tight"
            >
              {c}
            </span>
          ))}
        </div>
        <div className="pointer-events-none absolute inset-y-0 left-0 w-32 bg-gradient-to-r from-background to-transparent" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-32 bg-gradient-to-l from-background to-transparent" />
      </div>
    </section>
  );
}
